import React from 'react';

const AccessDenied: React.FC = () => (
  <div style={{ textAlign: 'center', marginTop: '40px' }}>
    <h2>Access Denied</h2>
    <p>You do not have permission to view this page.</p>
  </div>
);

export default AccessDenied;
